import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ButtonHome = ({ closeModal }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        closeModal();
        navigate('/');
    };

    return (
        <button className="mute-button lg:w-14 lg:h-14 sm:w-10 sm:h-10" onClick={handleClick}>
            <FontAwesomeIcon icon={faHome} className='lg:text-2xl sm:text-xl' />
        </button>
    );
};

export default ButtonHome;
